import { useLocation, Link } from 'react-router-dom';
import { HasPermission } from '@shared/components';
import { PermissionFeature } from '@shared/const';
import { useTranslation } from 'react-i18next';
import { Button } from '@ui/components';
import { Routes } from '@shared/enums';

const getNavigationItems: (p: string) => {
  permissionFeature: PermissionFeature;
  disabled?: boolean;
  isActive: boolean;
  label: string;
  path: string;
}[] = (pathname: string) => [
  {
    label: 'FILES_REPORTS.NAVIGATION.TRANSACTION_HISTORY',
    path: `../${Routes.TRANSACTION_HISTORY}`,
    isActive: pathname.includes(`${Routes.FILES_REPORTS}/${Routes.TRANSACTION_HISTORY}`),
    permissionFeature: 'REPORTS_FILES_TRANSACTION_HISTORY',
  },
  {
    label: 'FILES_REPORTS.NAVIGATION.REPORTS',
    path: `../${Routes.REPORTS}`,
    isActive: pathname.includes(`${Routes.FILES_REPORTS}/${Routes.REPORTS}`),
    permissionFeature: 'REPORTS_FILES_REPORTS',
  },
  {
    label: 'FILES_REPORTS.NAVIGATION.INVOICING',
    path: `../${Routes.INVOICING}`,
    isActive: pathname.includes(`${Routes.FILES_REPORTS}/${Routes.INVOICING}`),
    permissionFeature: 'REPORTS_FILES_INVOICING',
  },
];

export const FilesReportsNavigation = () => {
  const { t } = useTranslation();
  const { pathname } = useLocation();

  const navigationItems = getNavigationItems(pathname);

  return (
    <div className="flex gap-4 mb-4">
      {navigationItems.map(({ isActive, disabled, label, path, permissionFeature }) => (
        <HasPermission permissionFeature={permissionFeature} permissionType="READ" key={label}>
          <Button variant={isActive ? 'secondary' : 'link'} disabled={disabled}>
            <Link to={path}>{t(label)}</Link>
          </Button>
        </HasPermission>
      ))}
    </div>
  );
};
